import { SvgIcon, SvgIconProps } from '@mui/material';

const ExpandArrowsIcon = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M7 19L1 19M1 19L1 13M1 19L8 12M13 0.999999L19 1M19 1L19 7M19 1L12 8"
        stroke="#101828"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ExpandArrowsIcon;
